import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchPracticeProblemsByRole,
  setSelectedRole,
} from "../components/features/courses/courseSlice";

const usePracticeDataFromRole = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedRole, courseDetails, lessonList, showSpinner } = useSelector(
    (state) => state.courses
  );

  const [initialRole, setInitialRole] = useState("{Your Role}");

  const roleFromUrl = location.pathname.split("/")[2];

  useEffect(() => {
    if (roleFromUrl) {
      const formattedRole = roleFromUrl
        .split("-")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");

      // dispatch(getLesson(formattedRole));
      dispatch(setSelectedRole(formattedRole));
      setInitialRole(formattedRole);
      dispatch(fetchPracticeProblemsByRole(formattedRole));
    }
  }, [dispatch, roleFromUrl]);

  const handleRoleChange = (role) => {
    const formattedRole = role
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    dispatch(setSelectedRole(formattedRole));
    setInitialRole(formattedRole);
    navigate(`/practice/${role.toLowerCase()}`);
  };

  return {
    initialRole,
    selectedRole,
    courseDetails,
    lessonList,
    showSpinner,
    handleRoleChange,
  };
};

export default usePracticeDataFromRole;
